"use client";

import Link from "next/link";

interface HeaderProps {
  title: string;
  subtitle: {
    text: string;
    linkText?: string;
    linkHref?: string;
  };
}

export const Header = ({ title, subtitle }: HeaderProps) => {
  const handleToggleClick = () => {
    if (typeof window !== "undefined" && window.posthog?.capture) {
      const switchingTo = subtitle.linkHref?.includes("login")
        ? "login"
        : "signup";
      window.posthog.capture("auth_toggle_clicked", {
        from: switchingTo === "login" ? "signup" : "login",
        to: switchingTo,
      });
    }
  };

  return (
    <div>
      <h2 className="text-center text-4xl font-rounded-bold mb-4">{title}</h2>
      <p className="text-center text-[14px] whitespace-pre-line leading-4 mb-4">
        {subtitle.text}{" "}
        {subtitle.linkText && subtitle.linkHref && (
          <Link
            href={subtitle.linkHref}
            className="text-[#05afff]"
            onClick={handleToggleClick}
          >
            {subtitle.linkText}
          </Link>
        )}
      </p>
    </div>
  );
};
